import React from 'react';
import { ReactComponent as DeleteIcon } from 'images/delete.svg';
import { ReactComponent as OpenBin } from 'images/openBin.svg';
import { RemoveText } from './RemovePlayerStyles';

interface IProps {
  overDrop: boolean;
}

const RemovePlayerContainer: React.FC<IProps> = (props) => {
  const { overDrop } = props;

  return (
    <>
      {overDrop ? <OpenBin /> : <DeleteIcon />}
      <RemoveText>{overDrop ? 'Release to remove player' : 'Drag down to remove player'}</RemoveText>
    </>
  );
};

export default RemovePlayerContainer;
